import request from "../util/client";
import { LocaleString } from "../util/i18n";
import { ListParams, ListResponse } from "./types";

interface loginParams {
    username: string;
    password: string;
    captcha: string;
    captcha_key: string;
}

interface loginResponse {
    access_token: string;
    refresh_token: string;
}

export function login(params: loginParams) {
    return request<loginResponse>('admin', 'POST', params);
}

type getOperationParams = ListParams<{
    code?: string;
    granted?: any;
    user_id?: string;
}>;

export type OperationData = {
    package_id?: number | null;
    code: string;
    alias: string;
    description: LocaleString;
    granted?: boolean;
};

export function getOperation(params?: getOperationParams) {
    return request<ListResponse<OperationData>>('admin/operation', 'GET', params);
}

export function isOperationGranted(params: { operation: string | Array<string>, user_id?: number | string }) {
    return request<never>('admin/operation', 'HEAD', params);
}

export interface UserData {
    id: number;
    username: string;
    email: string;
    info: any;
    password?: string;
    status: number;
}

export function getUser(params: ListParams<Partial<UserData>>) {
    return request<ListResponse<UserData>>('admin/user', 'GET', params);
}

export function getMyProfile() {
    return request<UserData>('admin/me', 'GET');
}

export function saveUser(params: FormData | Partial<UserData>) {
    return request<{ data: number, password: string, message: string }>('admin/user', 'PATCH', params);
}

export function deleteUser(params: { id: number }) {
    return request<string>('admin/user', 'DELETE', params);
}

export interface RoleData {
    id: number;
    parent_id: string | Array<number>;
    name: string;
    privilege: number;
}

export function getRole(params: ListParams<Partial<RoleData>>) {
    return request<ListResponse<RoleData>>('admin/role', 'GET', params);
}

export function saveRole(params: FormData | Partial<RoleData>) {
    return request<{ data: number, message: string }>('admin/role', 'PATCH', params);
}

export function deleteRole(params: { id: number }) {
    return request<string>('admin/role', 'DELETE', params);
}

export function changePassword(params: { user_id?: number, password: string }) {
    return request<{ message: string, password: string }>('admin/password', 'PATCH', params);
}

export interface LogData {
    id: number;
    type: number;
    user_id: number;
    sku: string;
    status: number;
    created_at: number;
    remark?: {
        reason: string;
        comments: string;
        part: string[];
        order_id_reason?: string;
        images?: string[];
    }
}

export function getLogs(params: ListParams<Partial<LogData>> & { group: string, timezone?: string }): Promise<Array<{ point: number, date: string }> | string>;
export function getLogs(params: ListParams<Partial<LogData>>): Promise<Omit<ListResponse<LogData>, 'total'> & { total: Array<{ count: number, status: number }> } | string>;
export function getLogs(params: ListParams<Partial<LogData>>): Promise<Array<{ point: number, date: string }> | Omit<ListResponse<LogData>, 'total'> & { total: Array<{ count: number, status: number }> } | string> {
    return request('admin/kpi', 'GET', params);
}

export function getLogsStat(params: { group: string, timezone?: string, filter: Partial<LogData> }) {
    return request<Array<{ date: string, point: number, qty: number, users: number }>>('admin/kpi/stat', 'GET', params);
}

export function saveLogs(params: { id: number | number[], status: number }) {
    return request<string>('admin/kpi', 'PATCH', params);
}

export function deleteLogs(id: number | number[]) {
    return request<string>('admin/kpi', 'DELETE', { id });
}
